<template>
  <div class="bg-impact-row" :class="{ paid }">
    <div class="bg-impact-label">
      <span class="text-gray" v-if="kind === 'transfer'">Repasse </span>
      <span class="text-gray" v-else-if="kind === 'receivable'">Título </span>
      <b>{{ label }}</b>
      <span class="text-xs text-gray" v-if="detail"> {{ detail }}</span>
    </div>
    <div class="tnum">
      {{ from | currency }}
      <span class="bg-impact-arrow"><fa-icon :icon="['fal', 'arrow-right']"/></span>
      <b>{{ to | currency }}</b>
    </div>
    <div class="bg-impact-delta" :class="deltaClass">{{ deltaText }}</div>
    <div class="bg-impact-state" :class="paid ? 'text-amber' : 'text-green'">
      <template v-if="paid">
        <fa-icon :icon="['fal', 'exclamation-triangle']"/> {{ paidText }}
      </template>
      <template v-else>
        <fa-icon :icon="['fal', 'check']"/> {{ openText }}
      </template>
    </div>
  </div>
</template>

<script>
import { round2, num } from '../helpers';

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    detail: {
      type: String,
      default: null,
    },
    from: {
      type: Number,
      default: 0,
    },
    to: {
      type: Number,
      default: 0,
    },
    delta: {
      type: Number,
      default: null,
    },
    paid: {
      type: Boolean,
      default: false,
    },
    kind: {
      type: String,
      default: 'receivable',
    },
  },
  computed: {
    deltaValue() {
      return this.delta !== null ? round2(this.delta) : round2(num(this.to) - num(this.from));
    },
    deltaClass() {
      if (this.deltaValue < 0) return 'neg';
      if (this.deltaValue > 0) return 'pos';
      return 'zero';
    },
    deltaText() {
      const sign = this.deltaValue < 0 ? '−' : '+';
      return `${sign}${this.$options.filters.currency(Math.abs(this.deltaValue))}`;
    },
    paidText() {
      if (this.kind === 'transfer') return 'já pago: vira ajuste no próximo repasse';
      return 'já baixado: a glosa é registrada sem alterar o financeiro';
    },
    openText() {
      if (this.kind === 'transfer') return this.deltaValue < 0 ? 'aberto · abatido' : 'aberto · acrescido';
      return 'aberto · valor ajustado';
    },
  },
};
</script>
